import React from "react";
import BaseLayout from "../components/layout/BaseLayout";
import TextContainer from "../components/layout/TextContainer";
import CheckIcon from '@mui/icons-material/Check';
import LandingPageSubscribeBtn from "../components/general/LandingPageSubscribeBtn";
import Logo from "../components/layout/Logo";
import ProbeAnimation from "../components/channel-recommender/probe-animation/ProbeAnimation";
import ClosenessAnimation from "../components/channel-recommender/probe-animation/ClosenessAnimation";
import UserPlanGuard from "../components/auth/plans/UserPlanGuard";
import ActionButton from "../components/general/ActionButton";
import Link from "next/link";
import { Button } from "@mui/material";
import FormatedNumber from "../components/general/FormatedNumber";
import SatoshiToUsd from "../components/general/SatoshiToUsd";


export default function LandingPage() {


  return (
    <BaseLayout pageTitle="Channel Recommender"
      seoDescription="Use the channel recommender to create a powerful Lightning node with fast payments and high payment delivery success."
      shareDescription="Use the channel recommender to create a powerful Lightning node with fast payments and high payment delivery success."
      disableOnMaintenance={false}
      showAdvertisement={false}
      disableEmailConfirmationAd={true}
      >

      <div className="bg-gradient-to-b from-gradientLight to-viking-500 pt-16 text-gray-900 px-2">
        <div className="pt-8 pb-8 lnrouter-container">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            <div>
              <h1 className="font-extrabold text-4xl md:text-6xl leading-[1.1] mb-4 mt-12">
                Personalized Channel Recommender
              </h1>
              <p className=" text-2xl pb-4">
                Create a powerful node with channel recommendations for fast payments. Don't let your users wait.
              </p>
              <div className="">
                <LandingPageSubscribeBtn size={"small"} />
                <UserPlanGuard mustBe="SUBSCRIBED">
                  <Link href="/channel-recommender">
                    <a>
                      <ActionButton design="action">
                        <span className="text-lg">Go to Recommendations</span>
                      </ActionButton>
                    </a>
                  </Link>

                </UserPlanGuard>
              </div>
            </div>
            <div className="flex justify-center items-center">
              <svg className="w-full max-w-[500px]" viewBox="0 0 1246 830" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_579_581)">
                  <rect x="604.252" y="348" width="362" height="16.516" transform="rotate(67.4347 604.252 348)" fill="#4ADDDE" />
                  <rect x="542.896" y="328.53" width="362" height="16.516" transform="rotate(125.896 542.896 328.53)" fill="#4ADDDE" />
                  <rect x="1086.05" y="300.638" width="464.117" height="16.516" transform="rotate(-178.997 1086.05 300.638)" fill="#4ADDDE" />
                  <rect x="560.72" y="285.669" width="464.117" height="16.516" transform="rotate(-158.478 560.72 285.669)" fill="#4ADDDE" />
                  <circle cx="567" cy="286" r="100" fill="#A4103F" />
                  <circle cx="104" cy="100" r="100" fill="#A4103F" />
                  <circle cx="1142" cy="293" r="100" fill="#A4103F" />
                  <circle cx="754" cy="722" r="100" fill="#A4103F" />
                  <circle cx="304" cy="650" r="100" fill="#A4103F" />
                </g>
                <defs>
                  <filter id="filter0_d_579_581" x="0" y="0" width="1246" height="830" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_579_581" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_579_581" result="shape" />
                  </filter>
                </defs>
              </svg>
            </div>
          </div>

        </div>

      </div>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path fill="#4adddf" fillOpacity="1" d="M0,128L16,144C32,160,64,192,96,208C128,224,160,224,192,213.3C224,203,256,181,288,181.3C320,181,352,203,384,181.3C416,160,448,96,480,90.7C512,85,544,139,576,154.7C608,171,640,149,672,170.7C704,192,736,256,768,250.7C800,245,832,171,864,144C896,117,928,139,960,170.7C992,203,1024,245,1056,256C1088,267,1120,245,1152,202.7C1184,160,1216,96,1248,101.3C1280,107,1312,181,1344,176C1376,171,1408,85,1424,42.7L1440,0L1440,0L1424,0C1408,0,1376,0,1344,0C1312,0,1280,0,1248,0C1216,0,1184,0,1152,0C1120,0,1088,0,1056,0C1024,0,992,0,960,0C928,0,896,0,864,0C832,0,800,0,768,0C736,0,704,0,672,0C640,0,608,0,576,0C544,0,512,0,480,0C448,0,416,0,384,0C352,0,320,0,288,0C256,0,224,0,192,0C160,0,128,0,96,0C64,0,32,0,16,0L0,0Z"></path>
      </svg>

      <div className="mt-12 mb-32 ">

        <div>
          <div className="flex justify-center">

          </div>
          <div className="lnrouter-container">
            <div className="pt-8 xl:px-48">
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
                <p className="bg-viking-400 font-extrabold italic px-4 py-2 text-2xl lg:text-3xl sm:col-span-3 text-center">
                  Lightning can be a pain.
                </p>
                <div className="bg-viking-200 rounded p-6 text-xl font-light">
                  Payment delivery is not guaranteed.
                </div>
                <div className="bg-viking-200 rounded p-6 text-xl font-light">
                  50% of all Lightning payments take more than 8.6 seconds.
                </div>
                <div className="bg-viking-200 rounded p-6 text-xl font-light">
                  Unreliable nodes make your payments stuck.
                </div>

              </div>
              <div className="flex items-center justify-center pt-24">
                <Logo />
                <p className=" font-extrabold italic px-4 py-2 text-2xl lg:text-3xl sm:col-span-3 text-center">
                  An attempt to improve routing.
                </p>
              </div>

            </div>
          </div>
        </div>

      </div>

      <div className="px-2 py-36 bg-[#0E4243] text-white">
        <div className="lnrouter-container md:grid lg:grid-cols-5 md:grid-cols-4 grid-cols-3">
          {/* Metric tiles */}
          <div className=" md:col-span-2">
            <ProbeAnimation />
          </div>
          {/* Text */}
          <div className="col-span-2 lg:col-span-3  text-left sm:pl-32 pt-12 md:pt-0">
            <h2 className="font-extrabold text-4xl leading-[1.1] mb-4 ">
              Improve payment speed
            </h2>
            <p className=" text-xl">
              Your direct peers have the biggest impact on your payment speed and delivery success.
              Only peers with liquid channels and a low response time can guarantee a fast payment.
              The recommender proposes high-quality peers only.
            </p>
            <a href="https://blog.lnrouter.app/lightning-payment-speed-2022" target="_blank">
                <button  className=" rounded px-4 py-1 font-medium text-lg border-white border mt-2 bg-transparent text-black hover:text-white hover:bg-black  hover:border-black">
                  <div className="capitalize text-white">
                    More Info
                  </div>
                </button>
              </a>
          </div>


        </div>

      </div>

      <div className="px-2 py-36 ">
        <div className="lnrouter-container sm:grid lg:grid-cols-5 md:grid-cols-4 grid-cols-3">
          {/* Metric tiles */}
          <div className=" md:col-span-2">
            {/* First element */}
            <img
              src="/imgs/preview/lnrouter_personalized.png"
              className="rounded border-2 border-viking-800" />

          </div>
          {/* Text */}
          <div className="col-span-2 lg:col-span-3  text-left sm:pl-32 pt-12 sm:pt-0 ">
            <h2 className="font-extrabold text-4xl leading-[1.1] mb-4 ">
              Tailor-Made recommendations
            </h2>
            <p className=" text-xl">
              No node is the same. Therefore no node gets the same recommendations.
              The engine proposes channels that improve your nodes unique ability to send payments.
            </p>
            {/* <div className="pt-6">
              <LandingPageSubscribeBtn size={"small"} />
            </div> */}
          </div>

        </div>

      </div>


      <div className=" bg-viking-500 text-black py-36">
        <div className="lnrouter-container grid sm:grid-cols-2 grid-cols-1">
          <div className="pr-24">
            <h2 className="font-extrabold text-3xl md:text-4xl leading-[1.1] mb-4 ">
              Connect better
            </h2>
            <div className="text-xl ">
              The recommender proposes nodes that optimize your graph position. Being better connected,
              makes you pay less fees and increases payment speed. You literally skip channels by doing that.
            </div>
            {/* <div className="mt-6">
              <LandingPageSubscribeBtn size={"small"} />
            </div> */}
          </div>
          <div className="flex pt-12 sm:pt-0">
            <ClosenessAnimation className="w-96" />
          </div>
        </div>



      </div>





      <div className="py-32 bg-viking-1000 text-white px-2 ">
        <TextContainer>
          <h2 className="font-extrabold text-3xl md:text-4xl leading-[1.1] mb-4 text-center ">
            Pricing
          </h2>
          <div className="flex justify-center">
            <div className="py-6 px-8 border drop-shadow-2xl rounded-xl bg-white text-black w-72">
              <p className="font-bold text-2xl mb-2 text-viking-700">PRO Plan</p>
              <p ><span className="text-2xl font-extrabold"><FormatedNumber value={25200} />sat</span>
                <span className="text-sm text-gray-400 font-normal"> = $<SatoshiToUsd satoshi={25200} decimals={1} /></span>
              </p>
              <p className="text-gray-400 text-xs">per month</p>

              <table className=" mt-6 text-sm font-light">
                <tbody>
                  <tr>
                    <td>
                      <CheckIcon color="inherit" fontSize="inherit" className="text-viking-500 mr-2 text-base" />
                    </td>
                    <td>
                      Routing Score
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <CheckIcon color="inherit" fontSize="inherit" className="text-viking-500 mr-2 text-base" />
                    </td>
                    <td>
                      Channel Recommender
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <CheckIcon color="inherit" fontSize="inherit" className="text-viking-500 mr-2 text-base" />
                    </td>
                    <td>
                      HTLC Response Times
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <CheckIcon color="inherit" fontSize="inherit" className="text-viking-500 mr-2 text-base" />
                    </td>
                    <td>
                      Unlimited Access
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="pt-8 text-center w-72 mx-auto">
            <LandingPageSubscribeBtn size="small" className="w-full" />
          </div>

        </TextContainer>

      </div>

      <div className="py-32  text-center text-xl px-2 ">

        <div className="pb-4 text-2xl font-bold">
          Explore The Lightning Network Now
        </div>

      </div>

    </BaseLayout>
  );
}
